// Inspired by Dominic Tobias article:
// https://dev.to/infensus/making-a-tiny-0-cost-css-in-js-solution-for-lightweight-components-and-apps-27p1

export * from './css';
export * from './useStyle';